import styled from '@emotion/styled';

interface Props {
    isSelected?: boolean;
}

function RadioCircle({ isSelected }: Props) {
    return (
        <Wrapper>
            <Circle data-selected={isSelected}>
                <Dot data-selected={isSelected} />
            </Circle>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    height: 24px;
    justify-content: center;
    width: 24px;
`;

const Circle = styled.div`
    align-items: center;
    border: 1px solid var(--color-icon-unselected);
    border-radius: var(--radius-full);
    display: flex;
    height: 18px;
    justify-content: center;
    transition: border 100ms linear;
    width: 18px;

    &[data-selected=true] {
        border: 2px solid var(--color-icon-default);
    }
`;

const Dot = styled.div`
    background-color: var(--color-icon-default);
    border-radius: var(--radius-full);
    height: 10px;
    transform: scale(0);
    transition: transform 150ms linear;
    width: 10px;

    &[data-selected=true] {
        transform: scale(1);
    }
`;

export default RadioCircle;
